module.exports = __webpack_public_path__ + "static/mail2-012a0fd5fd94957b885db20b71d93514.svg";